import styled from "styled-components";

export const PipefyStyles = styled.div`

  .pp-max-zindex {
    z-index: 10000000;
  }
  
  .pp-scroll {
    ::-webkit-scrollbar-track {
      background: #d9e3f0 !important;
      border: 9px #fff !important;
      border-radius: 10px !important;
      margin: 6px 0 !important;
    }

    ::-webkit-scrollbar-thumb {
      background: #c0d0e6 !important;
      border: 8px #fff !important;
      border-radius: 10px !important;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #9ebce7 !important;
    }

    ::-webkit-scrollbar-corner {
      background: 0 0 !important;
    }

    ::-webkit-scrollbar-button {
      height: 0 !important;
      width: 0 !important;
    }

    ::-webkit-scrollbar {
      height: 8px !important;
      width: 8px !important;
    }
  }

  .pp-title-description {
    color: #748396;
    font-size: 14px;
    font-weight: 600;
    word-break: break-all;
  }

  .span-description {
    font-weight: 400;
    font-size: 13px;
  }

  .text-value {
    color: #546575;
  }

  .font-light {
    font-weight: normal;
  }

  .pp-ico-bold-arrow-down,
  .pp-ico-bold-arrow-up {
    top: 33.4px;
  }

  .pp-flat-box-title {
    flex: 1 !important;
  }

  .pp-flat-box-main {
    flex: 1 !important;
    padding: 20px;

    .pp-flat-box-content {
      flex: 1 !important;
    }
  }

  .pp-flat-box {
    margin-bottom: 10px;
  }

  .pp-flat-box-children.pp-active {
    border: none !important;
  }

  .move-to {
    cursor: pointer;
    width: 100%;
    background: rgb(230, 236, 245);
    border-radius: 0 0 5px 5px;
    transition: all 200ms ease-in-out;
    flex: 1;
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    height: 71px;
    z-index: 10;

    &:disabled {
      cursor: not-allowed;

      &:hover {
        background: rgba(59, 91, 253, 0.1);

        p {
          font-size: 16px;
          color: #3b5bfd !important;
        }
      }
    }

    p {
      font-size: 16px;
      color: #3b5bfd !important;
    }

    &:hover {
      background: #3b5bfd;

      p {
        color: #fff !important;
      }
    }
  }

  .move-steps {
    z-index: 3;
    animation-duration: 200ms !important;
    bottom: 90px;
    position: absolute;
    border: 1px solid #3b5bfd;
    right: 20px;
    left: 20px;
    border-radius: 5px;
    height: auto;
    max-height: 70%;
    overflow-y: auto;
  }

  .move-header {
    padding: 25px 12px 25px 40px;
    background: rgba(59, 91, 253, 0.1);
    flex: 1;
    height: 70px !important;

    p {
      color: #3b5bfd;
      margin-right: 22px;
      font: 16px inter, -apple-system, BlinkMacSystemFont, segoe ui, Roboto,
        Oxygen-Sans, Ubuntu, Cantarell, helvetica neue, sans-serif;
    }
  }

  .move-body {
    padding: 10px 20px;

    .item {
      cursor: pointer;
      height: 48px;
      padding-right: 20px;
      padding-left: 20px;

      p {
        font: 16px inter, -apple-system, BlinkMacSystemFont, segoe ui, Roboto,
          Oxygen-Sans, Ubuntu, Cantarell, helvetica neue, sans-serif;
        font-weight: 600;
      }

      span {
        font-size: 26px;
      }

      &:hover {
        padding-right: 12px;
        background: rgba(59, 91, 253, 0.1);

        p {
          color: #3b5bfd;
        }

        span {
          color: #3b5bfd;
          font-size: 26px;
        }
      }
    }
  }

  .current-phase {
    position: relative;
    width: 20px;
    height: 20px;

    span::before {
      background: rgba(0, 206, 140, 0.2);
      border-radius: 100%;
      content: "";
      opacity: 1;
      padding: 9px;
      padding-top: 9px;
      padding-right: 9px;
      padding-bottom: 9px;
      padding-left: 9px;
      position: absolute;
      right: -1px;
      top: 0;
    }

    span::after {
      background: #00ce8c;
      border-radius: 100%;
      content: "";
      padding: 4px;
      padding-top: 4px;
      padding-right: 4px;
      padding-bottom: 4px;
      padding-left: 4px;
      position: absolute;
      right: 4px;
      top: 5px;
    }
  }
  span,
  h1,
  h2,
  h3,
  p {
    font-family: inter, -apple-system, BlinkMacSystemFont, segoe ui, Roboto,
      Oxygen-Sans, Ubuntu, Cantarell, helvetica neue, sans-serif;
    font-size: 14px;
  }

  .pp-radio {
    margin-bottom: 0 !important;
  }

  .pp-card-wrapper-full {
    width: 100%;
  }

  .d-flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  .flex-column {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
  }

  .pp-card-overlay {
    height: 100vh;
    height: -webkit-fill-available;
    top: 0;
  }

  .RIToolTip {
    position: absolute;
    top: 4px;
    left: 55%;
  }

  .input-note-correction {
    border: 1px solid #c0d0e6 !important;
    border-radius: 3px !important;
    padding: 15px 10px !important;
    resize: auto !important;

    &:focus,
    &:hover {
      border: 1px solid #3b5bfd !important;
    }
  }

  input[type=radio] {
    &:disabled, &.disabled {
    opacity: 0;
  }
  }

  @media (min-width: 1025px) {
    .pp-card-wrapper {
      height: calc(100vh - 70px);
      max-width: 1100px;
      position: relative;
    }

    .pp-card-left {
      width: 560px;
    }

    .pp-card-left .pp-scroll {
      padding-right: 0.8em;
    }

    .pp-card-right {
      margin-left: -10px;
    }
  }

  @media (max-width: 1024px) {
    .pp-card-wrapper {
      flex-direction: column;
      max-width: 100%;
      position: absolute;
    }

    .pp-card-overlay {
      overflow-y: scroll;
      justify-content: end;
      display: inherit;
    }

    .pp-card-left,
    .pp-card-right {
      max-width: 100%;
    }

    .RIToolTip {
      left: 30%;
    }
  }

  @media (max-width: 945px) {
    .RIToolTip {
      left: 35%;
    }
  }

  @media (max-width: 815px) {
    .RIToolTip {
      left: 40%;
    }
  }

  @media (max-width: 720px) {
    .RIToolTip {
      left: 45%;
    }
  }

  @media (max-width: 650px) {
    .RIToolTip {
      left: 50%;
    }
  }

  @media (max-width: 585px) {
    .RIToolTip {
      left: 60%;
    }
  }

  @media (max-width: 500px) {
    .RIToolTip {
      left: 70%;
    }
  }

  @media (max-width: 435px) {
    .RIToolTip {
      left: 80%;
    }
  }

  @media (max-width: 390px) {
    .RIToolTip {
      left: 90%;
    }
  }
`;

export const InputDate = styled.input`
  border: 1px solid #c0d0e6;
  border-radius: 3px;
  caret-color: #3b5bfd;
  color: #213547;
  font: 500 14px inter,-apple-system,BlinkMacSystemFont,segoe ui,Roboto,Oxygen-Sans,Ubuntu,Cantarell,helvetica neue,sans-serif;
  line-height: 1.4;
  padding: 0 10px;
  position: relative;
  width: 100%;
  z-index: 1

  &:-webkit-input-placeholder {
    color: #9aaabe;
    font-size: 14px;
    font-weight: 500
  }

  &:-moz-placeholder {
      color: #9aaabe;
      font-size: 14px;
      font-weight: 500
  }

  &:-moz-placeholder {
      color: #9aaabe;
      font-size: 14px;
      font-weight: 500
  }

  &:-ms-input-placeholder {
      color: #9aaabe;
      font-size: 14px;
      font-weight: 500
  }

  &:hover,&:focus {
      border: 1px solid #3b5bfd;
      outline: 0
  }

  &:focus {
      -webkit-box-shadow: 0 0 0 3px rgba(59,91,253,.1);
      box-shadow: 0 0 0 3px rgba(59,91,253,.1)
  }

  &:disabled, &:read-only {
    cursor: not-allowed;
    background-color: rgba(192,208,230,.1);
    border-color: #cdd9eb;
    color: #546575;

    &:hover {
      background-color: rgba(192,208,230,.1);

      p {
        font-size: 16px;
        color: #3b5bfd !important;
      }
    }

    &:focus {
      border-color: #cdd9eb
    }
  }
`;
